<template>
  <div class="__login_bg">
    <v-container class="grey lighten-5">
      <v-row justify="space-around" class="mt-16">
        <v-col cols="12" sm="4" md="4">
          <v-card class="mx-auto pa-12 pb-8 mt-4" elevation="8" style="background-color: #ffffffc2;" max-width="448" rounded="lg">
            <div class="text-center mb-5">
              <img width="200" :src="require('@/assets/img/logo.png')" alt="Logo">
            </div>
            <v-form ref="userLogin" @submit.prevent="login()" lazy-validation>
              <div class="text-subtitle-1 text-medium-emphasis">Account</div>
              <v-text-field
                  v-model="user.email" :rules="user.emailRules"
                  density="compact"
                  placeholder="Username or Email address"
                  prepend-inner-icon="mdi-email-outline"
                  variant="outlined">
              </v-text-field>
              <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
                Password

                <a class="text-caption text-decoration-none text-blue" href="#" rel="noopener noreferrer">
                  Forgot password?
                </a>
              </div>

              <v-text-field
                  v-model="user.password" :rules="user.passwordRules"
                  :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="visible ? 'text' : 'password'"
                  density="compact"
                  placeholder="Enter your password"
                  prepend-inner-icon="mdi-lock-outline"
                  variant="outlined"
                  @click:append-inner="visible = !visible"
              ></v-text-field>

              <v-btn type="submit" color="blue" size="large" variant="tonal" block>
                 Log In <v-icon icon="mdi-login"></v-icon>
              </v-btn>

              <v-card-text class="text-center">
                <a class="text-red text-decoration-none" href="http://182.163.112.216/demo" rel="noopener noreferrer">
                  <v-icon icon="mdi-home"></v-icon> Back Home
                </a>
              </v-card-text>
            </v-form>
          </v-card>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'LoginComponent',

  data: () => ({
    visible: false,
    user: {
      id: 1,
      name: "Mr. Admin",
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],

      password: '',
      passwordRules: [
        v => !!v || 'Password is required',
      ],

      access_token: 'abcdefgijk1234',
    }
  }),

  mounted() {
    if (this.$store.getters.isLoggedIn === true) {
      this.$helpers.toastAlert('warning', 'You Are Already Logged In')
      this.$router.push({ path: `/dashboard` });
    }
  },

  methods: {

    login() {
      this.$refs.userLogin.validate().then((res) => {
        if (res.valid) {
          this.$store.dispatch("login", this.user).then(response => {
            console.log("Full",response)
            this.$helpers.toastAlert('success', 'Login successfully')
            this.$router.push({ path: `/dashboard` });
          }).catch(error => {
            console.log(error)
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.v-checkbox .v-selection-control {
  min-height: 0!important;
}
.v-selection-control--density-default {
  --v-selection-control-size: 0!important;
}
</style>